import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  educationLevel?: string
}

const EducationLevel = ({ educationLevel }: Props) => {
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.spain.education_level')}
      description={educationLevel}
    />
  )
}

export default EducationLevel
